// assets/product-composicion.js
// Selector de porciones para la tabla de composición.
// Estructura JSON con porciones:
// { "footer": [...], "porciones": [{ "label": "17g", "composicion_por_dosis": [...] }, ...] }
// Sin porciones: { "footer": [...], "composicion_por_dosis": [...] }

(function() {
  'use strict';

  var SVG_ARROW = '<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M3.1384 6.02928C3.32935 5.80651 3.66472 5.78071 ' +
    '3.88749 5.97165L8.50009 9.92531L13.1127 5.97165C13.3355 5.78071 13.6708 5.80651 13.8618 6.02928C14.0527 ' +
    '6.25204 14.0269 6.58742 13.8042 6.77837L8.84582 11.0284C8.64688 11.1989 8.3533 11.1989 8.15436 11.0284L3.19602 ' +
    '6.77836C2.97326 6.58742 2.94746 6.25204 3.1384 6.02928Z" fill="black"/></svg>';

  function getWeight(label) {
    var match = label.match(/(\d+(?:[.,]\d+)?)/);
    return match ? parseFloat(match[1].replace(',', '.')) : Infinity;
  }

  function formatSubName(name) {
    if (name === name.toUpperCase()) return name;
    return name.charAt(0).toLowerCase() + name.slice(1);
  }

  function renderFooter(container, footerLines) {
    var el = container.querySelector('.composicion-footer');
    if (!footerLines || !Array.isArray(footerLines) || footerLines.length === 0) {
      if (el) el.style.display = 'none';
      return;
    }
    if (!el) {
      el = document.createElement('p');
      el.className = 'composicion-footer';
      var inner = container.querySelector('.product-composicion__inner');
      if (inner) inner.appendChild(el);
    }
    el.style.display = '';
    el.innerHTML = footerLines.map(function(line) {
      if (line.indexOf('DDR') !== -1 || line.indexOf('VRN') !== -1) {
        var idx = line.indexOf(': ');
        if (idx === -1) return '<em>' + line + '</em>';
        return '<em><strong>' + line.substring(0, idx) + '</strong>: ' + line.substring(idx + 2) + '</em>';
      }
      return line;
    }).join('<br>');
  }

  function renderComposicionTable(tab, items) {
    var tbody = tab.querySelector('.product-composicion-table tbody');
    if (!tbody || !items || !Array.isArray(items)) return;

    tbody.innerHTML = '';

    items.forEach(function(item) {
      if (item.dosis) {
        var groupTr = document.createElement('tr');
        groupTr.className = 'composicion-group-row';
        groupTr.innerHTML = '<td colspan="2"><span class="composicion-group-content">' +
          '<strong>' + item.ingrediente + '</strong>' +
          '<span class="composicion-group-dosis"><strong>' + item.dosis + '</strong></span>' +
          '</span></td>';
        tbody.appendChild(groupTr);

        if (item.de_las_cuales && Array.isArray(item.de_las_cuales)) {
          var itemPrefijo = item.prefijo || 'Del cual';
          item.de_las_cuales.forEach(function(child) {
            var tr = document.createElement('tr');
            tr.innerHTML = '<td>' + child.ingrediente + '</td>' +
              '<td>' + (child.cantidad || '') + '</td>';
            tbody.appendChild(tr);

            if (child.de_las_cuales && Array.isArray(child.de_las_cuales)) {
              var childPrefijo = child.prefijo || itemPrefijo;
              child.de_las_cuales.forEach(function(sub) {
                var subTr = document.createElement('tr');
                subTr.className = 'composicion-sub-row';
                subTr.innerHTML = '<td>' + childPrefijo + ' ' + formatSubName(sub.ingrediente) + '</td>' +
                  '<td>' + (sub.cantidad || '') + '</td>';
                tbody.appendChild(subTr);
              });
            }
          });
        }
      } else {
        var tr = document.createElement('tr');
        tr.innerHTML = '<td>' + item.ingrediente + '</td>' +
          '<td>' + (item.cantidad || '') + '</td>';
        tbody.appendChild(tr);

        if (item.de_las_cuales && Array.isArray(item.de_las_cuales)) {
          var prefijo = item.prefijo || 'Del cual';
          item.de_las_cuales.forEach(function(sub) {
            var subTr = document.createElement('tr');
            subTr.className = 'composicion-sub-row';
            subTr.innerHTML = '<td>' + prefijo + ' ' + formatSubName(sub.ingrediente) + '</td>' +
              '<td>' + (sub.cantidad || '') + '</td>';
            tbody.appendChild(subTr);
          });
        }
      }
    });
  }

  window.initComposicionSelector = function(tab) {
    var existing = tab.querySelector('.composicion-selector');
    if (existing) existing.remove();

    var button = tab.querySelector('.m-collapsible--button');
    var dataScript = tab.querySelector('.composicion-data');
    if (!button || !dataScript) return;

    var rawData;
    try { rawData = JSON.parse(dataScript.textContent); } catch (e) { return; }

    var porciones = rawData.porciones;
    if (!porciones || !Array.isArray(porciones) || porciones.length === 0) return;

    porciones.sort(function(a, b) { return getWeight(a.label) - getWeight(b.label); });

    var contentContainer = tab.querySelector('.collapsible-composicion-content') || tab;
    renderFooter(contentContainer, rawData.footer);

    renderComposicionTable(tab, porciones[0].composicion_por_dosis);

    if (porciones.length === 1) {
      var staticWrapper = document.createElement('div');
      staticWrapper.className = 'composicion-selector';
      staticWrapper.style.cssText = 'position:absolute; right:4rem; display:none; align-items:center;';
      staticWrapper.addEventListener('click', function(e) { e.stopPropagation(); });
      var staticDisplay = document.createElement('div');
      staticDisplay.className = 'composicion-selector-display';
      staticDisplay.style.cssText = 'position:relative; display:flex; align-items:center; z-index:1; left:8%;';
      var staticText = document.createElement('span');
      staticText.className = 'composicion-selected-text';
      staticText.textContent = porciones[0].label;
      staticText.style.setProperty('font-size', '14px', 'important');
      staticText.style.setProperty('font-weight', 'normal', 'important');
      staticText.style.setProperty('line-height', 'normal', 'important');
      staticText.style.setProperty('white-space', 'normal', 'important');
      staticDisplay.appendChild(staticText);
      var vrnLabel = porciones[0].vrn_label || '';
      if (vrnLabel) {
        var vrnEl = document.createElement('span');
        vrnEl.className = 'composicion-vrn-text';
        vrnEl.innerHTML = vrnLabel;
        vrnEl.style.setProperty('font-size', '14px', 'important');
        vrnEl.style.setProperty('line-height', 'normal', 'important');
        vrnEl.style.setProperty('margin-left', '0', 'important');
        vrnEl.style.setProperty('white-space', 'nowrap', 'important');
        staticDisplay.appendChild(vrnEl);
      }
      staticWrapper.appendChild(staticDisplay);
      button.style.position = 'relative';
      button.appendChild(staticWrapper);
      var obs = new MutationObserver(function(muts) {
        muts.forEach(function(m) {
          if (m.attributeName === 'aria-expanded') {
            staticWrapper.style.display = button.getAttribute('aria-expanded') === 'true' ? 'flex' : 'none';
          }
        });
      });
      obs.observe(button, { attributes: true });
      if (button.getAttribute('aria-expanded') === 'true') {
        staticWrapper.style.display = 'flex';
      }
      return;
    }

    var selectorWrapper = document.createElement('div');
    selectorWrapper.className = 'composicion-selector';
    selectorWrapper.style.cssText = 'position:absolute; right:4rem; display:none; align-items:center; cursor:pointer;';
    selectorWrapper.addEventListener('click', function(e) { e.stopPropagation(); });

    var arrowIcon = document.createElement('span');
    arrowIcon.className = 'composicion-selector-arrow';
    arrowIcon.innerHTML = SVG_ARROW;

    var select = document.createElement('select');
    select.id = 'composicion-portion';
    select.style.cssText = 'position:absolute; left:0; top:0; width:100%; height:100%; opacity:0; cursor:pointer; z-index:2; border:none; background:transparent;';
    select.addEventListener('click', function(e) { e.stopPropagation(); });
    select.addEventListener('focus', function() { arrowIcon.classList.add('rotated'); });
    select.addEventListener('blur', function() { arrowIcon.classList.remove('rotated'); });
    select.addEventListener('change', function() {
      setTimeout(function() {
        if (document.activeElement !== select) arrowIcon.classList.remove('rotated');
      }, 100);
    });

    var displayContent = document.createElement('div');
    displayContent.className = 'composicion-selector-display';
    displayContent.style.cssText = 'position:relative; display:flex; align-items:center; pointer-events:none; z-index:1; left:8%;';

    var selectedText = document.createElement('span');
    selectedText.className = 'composicion-selected-text';
    selectedText.textContent = porciones[0].label;
    selectedText.style.setProperty('font-size', '14px', 'important');
    selectedText.style.setProperty('font-weight', 'normal', 'important');
    selectedText.style.setProperty('line-height', 'normal', 'important');
    selectedText.style.setProperty('white-space', 'normal', 'important');
    displayContent.appendChild(selectedText);

    var vrnText = document.createElement('span');
    vrnText.className = 'composicion-vrn-text';
    var firstVrn = porciones[0].vrn_label || '';
    vrnText.innerHTML = firstVrn;
    vrnText.style.setProperty('font-size', '14px', 'important');
    vrnText.style.setProperty('line-height', 'normal', 'important');
    vrnText.style.setProperty('margin-left', '0', 'important');
    vrnText.style.setProperty('white-space', 'nowrap', 'important');
    if (!firstVrn) vrnText.style.display = 'none';
    displayContent.appendChild(vrnText);

    displayContent.appendChild(arrowIcon);
    selectorWrapper.appendChild(displayContent);
    selectorWrapper.appendChild(select);

    porciones.forEach(function(p, i) {
      var opt = document.createElement('option');
      opt.value = i;
      opt.textContent = p.label;
      if (i === 0) opt.selected = true;
      select.appendChild(opt);
    });

    button.style.position = 'relative';
    button.appendChild(selectorWrapper);

    select.addEventListener('change', function() {
      var idx = parseInt(select.value);
      var portion = porciones[idx];
      if (portion) renderComposicionTable(tab, portion.composicion_por_dosis);
      selectedText.textContent = porciones[idx].label;
      var vrnLabel = porciones[idx].vrn_label || '';
      vrnText.innerHTML = vrnLabel;
      vrnText.style.display = vrnLabel ? '' : 'none';
    });

    var obs = new MutationObserver(function(muts) {
      muts.forEach(function(m) {
        if (m.attributeName === 'aria-expanded') {
          var expanded = button.getAttribute('aria-expanded') === 'true';
          selectorWrapper.style.display = expanded ? 'flex' : 'none';
        }
      });
    });
    obs.observe(button, { attributes: true });

    if (button.getAttribute('aria-expanded') === 'true') {
      selectorWrapper.style.display = 'flex';
    }
  };

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('collapsible-tab').forEach(function(tab) {
      if (tab.querySelector('.composicion-data')) {
        window.initComposicionSelector(tab);
      }
    });
  });
})();
